<template>
    <div id="app">
        <navbar-home :sections="sections" @section-clicked="onSectionClick" class="navbar-home"></navbar-home>
        <transition name="fade" :style="{minHeight:minHeight+'px'}">
            <router-view ></router-view>
        </transition>
        <page-footer class="page-footer"></page-footer>
    </div>
</template>

<script>
    import navbarHome from '@/components/shared/navbar2';
    import PageFooter from '@/components/shared/page-footer';
    import FancyHeader from '@/components/shared/fancy-header';

    export default {
        name: 'app',

        data: () => ({
            sections: [],
            minHeight:null,

        }),
        computed:{
            calculateMinHeight: function(){
                  let  winHeight = window.height,
                    navHeight = $('.navbar-home').height,
                    footerHeight = $('.page-footer').height;
                return this.minHeight = winHeight - (navHeight+footerHeight);
            }
        },
        methods: {

            onSectionClick(id) {
                NProgress.start();
                axios.get(apiHost + "/sections/" + id + "/products?all=true")
                    .then((response) => {
                        this.$refs.pricingOrderModal.showModal(id, response.data);
                        NProgress.done();
                    })
                    .catch((error) => {
                        NProgress.done();
                    });
            }
        },

        mounted() {
            axios.get(apiHost + "/sections")
            .then((response) => {
                this.sections = response.data;
            })
            .catch((error) => console.log(error));

        
        },

        components: {
            navbarHome,
            PageFooter,
            FancyHeader
        },
    }
</script>
<style lang="scss">
    @import "src/assets/sass/app.scss";

    .fade-enter-active, .fade-leave-active {
        transition-property: opacity;
        transition-duration: .25s;
    }

    .fade-enter-active {
        transition-delay: .25s;
    }

    .fade-enter, .fade-leave-active {
        opacity: 0
    }
</style>



// WEBPACK FOOTER //
// src/App.vue